import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';

import { ERROR_404_LABEL } from '@app/constants';
import { ERROR_404_NOT_FOUND } from '@app/constants/alerts';
import { PREFIX } from '@app/constants/appPrefix';

import '@app/components/Error404NotFound/styles/Error404NotFound.desktop.scss';

export const Error404NotFound = () => {
  return (
    <div className={`${PREFIX}error-404-not-found`}>
      <Result
        className="error-container"
        status="404"
        title={ERROR_404_LABEL}
        subTitle={ERROR_404_NOT_FOUND}
        extra={
          <Link to="/">
            <Button type="primary">На главную</Button>
          </Link>
        }
      />
    </div>
  );
};
